<template lang="">
  <ion-card @click="goMatch(match._id)"  class="custom-card">
    <ion-card-content>
      <section class="overview d-flex justify-between mb-1">
        <div class="mb-1">
          <span class="c-yellow f-bold">Round {{ match?.round?.name || match?.round?.number }}</span>
          <h5 class="c-white bold-title date-time"> {{ moment(dateTime).format('LLL')}} </h5>
          <span class="c-gray">{{get(venue, 'name', 'TBA')}} {{get(meta, 'field.name')}}</span>
        </div>
        <div class="status">
          <ion-badge
            v-if="match.currentSetId && status === 'sets'"
            color="light"
            class="gap-05 in-progress-box text-center flex align-center p-10">
              <div class="dot"></div>
              <p>Set {{ match.currentSetId }}</p>
            </ion-badge>
          <ion-badge
          v-else-if="status === 'first-half' || status === 'second-half'"
          :color="gameStatusColor(status)"
          class="mb-05 gap-05 in-progress-box text-center flex align-center p-10">
            <div class="dot"></div>
            <p>{{ upperCase(status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('PENALTY', 'Penalties') }}</p>
          </ion-badge>
          <ion-badge v-else :color="gameStatusColor(status)"
            class="mb-05 text-center flex align-center p-10">
            <ion-icon v-if="checkForfeit('homeTeam',status,meta,homeTeam)" :icon="arrowBackOutline">
            </ion-icon>{{ upperCase(status) }}<ion-icon
              v-if="checkForfeit('awayTeam',status,meta,awayTeam)" :icon="arrowForwardOutline">
            </ion-icon>
          </ion-badge>
        </div>
      </section>
      <div class="d-flex flex-column gap-025">
        <div class="d-flex justify-between align-center gap-10">
          <div class="d-flex gap-10 align-center">
            <TeamLogo :team="homeTeam" :small="true" />
            <div class="bold-title team-name mt-10">{{get(homeTeam, 'name', meta && !!meta.isBye ? 'BYE' : 'TBA')}}</div>
          </div>
          <div class="c-white bold-title score-text">{{getScore('homeTeam', scoringEvents, scores,status,meta,homeTeam, competitionId)}}</div>
        </div>
        <div class="d-flex justify-between align-center gap-10">
          <div class="d-flex gap-10 align-center">
            <TeamLogo :team="awayTeam" :small="true" />
            <div class="bold-title team-name mt-10">{{get(awayTeam, 'name', meta && !!meta.isBye ? 'BYE' : 'TBA')}}</div>
          </div>
          <div class="c-white bold-title score-text">{{getScore('awayTeam', scoringEvents, scores,status,meta,awayTeam, competitionId)}}</div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import TeamLogo from '../views/matches/base/team-logo.vue'

export default {
  name: 'MatchCard',
  props: {
    match: {
      type: Object,
      required: true
    },
    competitionId: {
      type: Number,
      required: true
    },
  },
  components: { TeamLogo },
  data() {
    return {
      moment,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      compeititonId: this.match?.competition?._id,
      venue: this.match.venue,
      meta: this.match.meta,
      scores: this.match.scores,
      scoringEvents: this.match.scoringEvents,
      weather: this.match.weather,
      homeTeam: this.match.homeTeam,
      awayTeam: this.match.awayTeam,
      dateTime: this.match.dateTime,
      status: this.match.status
    }
  },
  computed: {
    entity() {
      return this.$store.getters['national/getEntity'];
    },
  },
  methods: {
    checkForfeit(type,status,meta,team){
      if(type === 'homeTeam'){
        if(status === 'forfeit'){
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }else if( type === 'awayTeam'){
        if(status === 'forfeit') {
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }
    },
    getScore(type, scoringEvents, scores, status, meta, team, competitionId) {
      const hasPenaltyPeriod = scoringEvents ? scoringEvents.some(ev => ev?.name?.toLowerCase()?.includes('penalty') && ev?.period === 9999) : false;
      if (type === 'homeTeam' || type === 'awayTeam') {
        if (status === 'forfeit') {
          // const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          // const competition = _.find(this.competitions, { _id: competitionId });
          // return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
          // Commented out old code, the this.competitions is not defined in this component
          const score = type === 'homeTeam' ? _.get(scores, 'homeTeam', 0) : _.get(scores, 'awayTeam', 0);
          return score;
        }
        if (status === 'penalty' || hasPenaltyPeriod) {
          const mainScore = _.get(scores, `${type}`, 0);
          const penScoreEvents = scoringEvents
            .filter(ev =>
              ev?.name?.toLowerCase()?.includes('penalty') &&
            !ev?.name?.toLowerCase()?.includes('miss') &&
            ev?.teamId === team?._id
            );
          const penScore = penScoreEvents
            .reduce((acc, cur) => acc + 1, 0);
          const penScoreValues = penScoreEvents
            .reduce((acc, cur) => acc + cur.value, 0);
          return type === 'homeTeam' ? `${mainScore - penScoreValues} (${penScore}) ` : `${mainScore - penScoreValues} (${penScore})`;
        }
        return _.get(scores, `${type}`, 0);
      }
    },
    getHomeScore(scores,status,meta,homeTeam, competitionId){
      if(status === 'forfeit'){
        const competition = _.find(this.competitions, { _id: competitionId });
        const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(homeTeam, 'name');
        return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
      }
      else{
        return _.get(scores, 'homeTeam', 0);
      }
    },
    getAwayScore(scores,status,meta,awayTeam, competitionId){
      if(status === 'forfeit'){
        const competition = _.find(this.competitions, { _id: competitionId });
        const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(awayTeam, 'name');
        return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
      }
      else{
        return _.get(scores, 'awayTeam', 0);
      }
    },
    isLastIndex(round, index) {
      const nextIndex = index+1;
      if(!this.filteredMatches[nextIndex]) return true;
      return round.number !== this.filteredMatches[nextIndex].round.number;
    },
    getByes(round) {
      const res = _.filter(this.byes, g=> g.round.number === round.number);
      return res;
    },
    // getWeatherIcon(name) {
    //   var images = require.context('../assets/weather-icons/', false, /\.svg$/)
    //   return images('./' + name + ".svg")
    // },
    goMatch(id) {
      if(this.entity && this.entity?.level && this.entity?.name){
        this.$router.push(`/c/${this.entity?.level}/${this.entity?.name}/matches/${id}`);
        return;
      }
      this.$router.push(`/matches/${id}`);

    },
    goToAS() {
      window.open('https://assemblesports.com', "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand =  Math.random();
      return rand  <= (freq / 100);
    },
    segmentChanged(event) {
      this.segment = event.detail.value;
      if(this.segment === 'matches'){
        this.ladderSegment = 'ladderBoard';
      }else{
        this.ladderSegment = 'ladderBoard';
      }
    },
    ladderSegmentChanged(event) {
      this.ladderSegment = event.detail.value;
    },
    setSegment(){
      if (this.filteredMatches.length > 0) this.segment = 'matches';
      else if(Object.keys(this.ladder).length > 0) this.segment = 'ladder';
      else this.segment = 'matches';
    },
    gameStatusColor(status) {
      switch (status) {
      case 'pre-game':
        return 'light';
      case 'final':
        return 'success';
      case 'forfeit':
      case 'washout':
        return 'warning';
      case 'disputed':
      case 'offline':
        return 'danger';
      case 'first-half':
      case 'second-half':
        return 'light';
      default:
        return 'light';
      }
    },
  }
}
</script>

<style lang="scss" scoped>

  .bold-title {
    max-width: none;
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
    // background: transparent;
    background: #171717 !important;
    &:hover {
      background: hsl(225, 6%, 14%) !important;
    }
    margin-inline: 1.5rem;
    margin-bottom: 1rem;

    .venue {
      letter-spacing: -0.01rem;
    }

    padding: 0.5rem;
  }

ion-badge {
  border-radius: 200px;
  height: 1.75rem;
}

.date-time {
  margin-top: 0.5rem;
  margin-bottom: -0.25rem;
}

.team-name {
  font-family: 'BrownStd-Regular';
  color: #ebebeb;
}

.score-text {
  font-size: 1.3rem;
}


.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}
</style>